import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  AdminOrderPaymentView,
  RefundOrderRequest,
} from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminOrderPayment } from "@/lib/query/core/invalidation";

type RefundStoreOrderInput = {
  storeId: string;
  orderId: string;
} & RefundOrderRequest;

type RefundStoreOrderResponse = {
  transaction: AdminOrderPaymentView;
};

export function useRefundStoreOrderMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: RefundStoreOrderInput) => {
      const { storeId, orderId, ...body } = input;
      return apiJsonClient<RefundStoreOrderResponse>(
        endpoints.admin.storeOrderRefund(storeId, orderId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      );
    },
    onSuccess: async (_data, variables) => {
      await invalidateAdminOrderPayment(
        queryClient,
        variables.storeId,
        variables.orderId,
      );
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
  };
}
